import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LineItem } from 'src/app/models/line-item';
import { InventoryService } from 'src/app/services/inventory.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ModalLineItemComponent } from 'src/app/components/inventory-modals/modal-line-item.component';

@Component({
  selector: 'app-purchase-order-line-items',
  template: `
  <div class="d-flex mb-4 mt-4">
    <h2>Orden de compra:</h2>
  </div>
  <div class="d-flex mb-4 mt-4">
    <div>
      <ul #subnav app-nav-inventory [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      <h4 class="mt-1 ms-3 mb-3" style="font-size: 1.2em">Ordenes de compra</h4>
      <ul #sidebar class="list-unstyled">            
        <li><button class="btn btn-zazz-default active rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/purchase-orders" >Ordenes de compra</button></li>
        <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/providers">Proveedores</button></li>
        <!-- li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/purchase-orders" >Compras</button></!-->
        <!-- li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/sales">Ventas</button></!-->
      </ul>
      <ul class="list-unstyled">
        <li><button class="btn btn-zazz-default active rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/parts" >Detalles de la orden</button></li>
        <!-- li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/purchase-orders/line-items/{{purchaseOrder?.pk}}">Productos</button></!-->
        <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/purchase-orders" >Inventario recibido</button></li>
        <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/sales">Notas</button></li>
      </ul>
    </div>
    <div class="flex-fill ms-3">
      <div class="d-flex">          
        <div class="flex-fill">
          <button class="btn btn-zazz-default rounded-4 shadow-sm px-4 ms-2" (click)="openModalLineItem()">
            <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
            Agregar
          </button>
        </div>
      </div>
      <div class="list-group rounded-5 shadow mt-4" >
        <div class="list-group-item w-100" >
          <table class="table table-sm" style="overflow-x: scroll;">
            <thead class="thead-dark">
              <tr class="">
                <th scope="col" class="text-start bg-zazz text-light py-2"># Parte <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                <th scope="col" class="text-start bg-zazz text-light py-2">Descripción </th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Referencia</th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Cantidad</th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Recibidos</th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Paquete</th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Cantidad paquete</th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Código proveedor</th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Precio unidad</th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Total precio</th>
                <th scope="col" class="text-center bg-zazz text-light py-2">Fecha estimada</th>
              </tr>
            </thead>
            <tbody>
              <tr app-tr-purchase-order-line-item
                [lineItem]="lineItem"
                [profile]="profile" 
                [permissions]="permissions"
                
                *ngFor="let lineItem of lineItems | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
              ></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <app-modal-line-item></app-modal-line-item>
  `,
  styleUrls: []
})
export class PurchaseOrderLineItemsComponent {
  @ViewChild(ModalLineItemComponent, { static: true }) modalLineItemComponent !: ModalLineItemComponent;
  lineItems: LineItem[] = [];
  profile: any;
  permissions: any;
  payload: any = {};
  meta: any = {};
  p: number = 1;

  currentView: string = 'purchaseOrders';

  constructor(
    private invService: InventoryService,
    private route: ActivatedRoute,
    public icons: IconsService,
  ) { 
    this.route.params.subscribe(params => {
      this.invService.getPurchaseOrderLineItems(params['id']).subscribe(data => {
        this.lineItems = data.results;
      });
    });
  }

  openModalLineItem() {
    const modalTemplate: any | undefined = this.modalLineItemComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalLineItem']);
    }
  }

}
